import { Faders } from "@phosphor-icons/react";
import { GenreQuickBar } from "@/components/GenreQuickBar";

const GENRES = ["All", "Action", "Adventure", "Anime", "Comedy", "Horror", "Sci-Fi", "Thriller", "Drama", "Crime", "Romance", "Music", "Documentary", "Nature"];
const YEARS = ["All", "2027", "2026", "2025", "2024", "2023", "2022", "2021", "2020"];
const SORTS = [
  { id: "top_rated", label: "Top Rated" },
  { id: "recent", label: "Most Recent" },
  { id: "watched", label: "Top Watched" },
];

const selectCls =
  "appearance-none bg-[#141414] border border-white/10 text-white/80 text-xs font-mono uppercase tracking-[0.12em] pl-3 pr-8 py-2 focus:outline-none focus:border-amber hover:border-amber/60 transition-colors cursor-pointer";

const Caret = () => (
  <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-white/40 text-[10px]">▾</span>
);

// Compact, always-visible sticky filter bar for the homepage. Sits directly under the
// top nav so users never have to hunt for Genre / Year / Sort controls.
export const HomeFilterBar = ({ genre, setGenre, year, setYear, sort, setSort }) => {
  const genreValue = genre ? genre.toLowerCase() : "all";
  return (
    <div
      data-testid="home-filter-bar"
      className="sticky top-[101px] sm:top-[103px] z-40 backdrop-blur-2xl bg-[#050505]/85 border-b border-white/10"
    >
      <GenreQuickBar active={genre} onPick={setGenre} />
      <div className="mx-auto max-w-[1600px] min-[2200px]:max-w-[2200px] px-4 sm:px-8 py-2.5 flex items-center gap-3 sm:gap-5 overflow-x-auto rv-scroll-x">
        <span className="hidden sm:flex items-center gap-2 shrink-0 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
          <Faders size={15} weight="duotone" className="text-amber" />
          Filters
        </span>

        <div className="relative shrink-0">
          <select
            data-testid="home-filter-genre"
            aria-label="Filter by genre"
            value={genreValue}
            onChange={(e) => setGenre(e.target.value === "all" ? "" : e.target.value)}
            className={selectCls}
          >
            {GENRES.map((g) => (
              <option key={g} value={g === "All" ? "all" : g.toLowerCase()}>
                {g === "All" ? "All Genres" : g}
              </option>
            ))}
          </select>
          <Caret />
        </div>

        <div className="relative shrink-0">
          <select
            data-testid="home-filter-year"
            aria-label="Filter by release year"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            className={selectCls}
          >
            {YEARS.map((y) => (
              <option key={y} value={y}>
                {y === "All" ? "Any Year" : y}
              </option>
            ))}
          </select>
          <Caret />
        </div>

        <div className="relative shrink-0">
          <select
            data-testid="home-filter-sort"
            aria-label="Sort films"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className={selectCls}
          >
            {SORTS.map((s) => (
              <option key={s.id} value={s.id}>
                {s.label}
              </option>
            ))}
          </select>
          <Caret />
        </div>

        {(genre || year !== "All" || sort !== "top_rated") && (
          <button
            data-testid="home-filter-clear"
            onClick={() => {
              setGenre("");
              setYear("All");
              setSort("top_rated");
            }}
            className="shrink-0 border border-white/10 text-white/60 text-[10px] font-mono uppercase tracking-[0.15em] px-3 py-2 hover:border-crimson hover:text-crimson transition-colors"
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
};
